import React, { useEffect, useState } from "react";
import useSave from "../../Hooks/useSave";
import useFetch from "../../Hooks/useFetch";
import useDelete from "../../Hooks/useDelete";
import Table from "./../../Components/Table";
import { Link } from "react-router-dom";
import Modal from "react-awesome-modal";
import Api from "../../Hooks/Api";
const OrganizationPerformance = (props) => {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [view, setview] = useState(false);
  const [ratingsOptions, setRatingOptions] = useState([]);
  const [update, setUpdate] = useState(false);
  const [organizationOptions, setOrganizations] = useState([]);
  const url = "api/organization-performance";
  const { state, FetchAll } = useFetch(url);
  const [yearsOptions, setyearsOptions] = useState([]);
  const fetchFinancialYear = async () => {
    try {
      Api.get("/api/financial-years")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setyearsOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  const fetchOrgs = async () => {
    try {
      Api.get("/api/organizations")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setOrganizations(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  const fetchRatings = async () => {
    try {
      Api.get("/api/org-performance-rating-scale")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setRatingOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  useEffect(() => {
    FetchAll();
    fetchOrgs();
    fetchFinancialYear();
    fetchRatings();
  }, []);

  const handleOpenModal = (event) => {
    event.persist();
    setInputs({});
    setOpen(true);
  };

  const handleInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const handleEdit = () => {
    if (inputs.reportId) {
      setOpen(true);
      setUpdate(true);
      setview(false);
    } else {
      alert("Select a record to edit");
    }
  };

  const handleView = () => {
    if (inputs.reportId) {
      setview(true);
      setUpdate(false);
      setOpen(true);
    } else {
      alert("Select a record to veiw");
    }
  };
  const handleSelect = (k, event) => {
    setInputs({});
    setInputs(k);
  };
  const handleCloseModal = () => {
    setOpen(false);
    setview(false);
  };

  const HandleSubmit = (event) => {
    event.preventDefault();
    useSave(url, inputs);
  };
  const CallDeletehook = () => {
    useDelete(url + "/delete?id=" + inputs.reportId);
  };
  const HandelDelete = () => {
    if (inputs.reportId) {
      CallDeletehook();
    } else {
      alert("Select a record to delete");
    }
  };
  const ColumnData = [
    {
      label: "Id",
      field: "reportId",
      sort: "asc",
    },
    {
      label: "Mda Name",
      field: "mdaName",
      sort: "asc",
    },
    {
      label: "Financial Year",
      field: "financialYear",
      sort: "asc",
    },
    {
      label: "Core Mandate Score",
      field: "coreMandateScore",
      sort: "asc",
    },
    {
      label: "Financial Score",
      field: "financialScore",
      sort: "asc",
    },
    {
      label: "Service Delivery Score",
      field: "serviceDeliveryScore",
      sort: "asc",
    },
    {
      label: "Composite Score",
      field: "compositeScore",
      sort: "asc",
    },
    {
      label: "Date Signed Off",
      field: "dateSignedOff",
      sort: "asc",
    },
    {
      label: "Evaluator Name",
      field: "evaluatorName",
      sort: "asc",
    },
    {
      label: "Rating Category",
      field: "ratingCategory",
      sort: "asc",
    },
  ];
  let Rowdata1 = [];
  const rows = state.data;
  if (rows.length > 0) {
    rows.forEach((k) => {
      const Rowdata = {
        clickEvent: () => handleSelect(k),
        mdaName: k.mdaName,
        financialYear: k.financialYear.name,
        coreMandateScore: k.coreMandateScore,
        reportId: k.reportId,
        financialScore: k.financialScore,
        serviceDeliveryScore: k.serviceDeliveryScore,
        compositeScore: k.compositeScore,
        dateSignedOff: k.dateSignedOff,
        evaluatorName: k.evaluatorName,
        ratingCategory: k.ratingCategory.gradeName,
      };
      Rowdata1.push(Rowdata);
    });
  }

  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active">Organization Performance</li>
      </ol>
      <h1 class="page-header mb-3">Organization Performance</h1>
      <div style={{ backgroundColor: "white" }}>
        <div className="row">
          <div class="col-sm-12 d-flex flex-row float-right">
            &nbsp; &nbsp; &nbsp;
            <button
              onClick={handleOpenModal}
              className="btn btn-success p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              New
            </button>
            <button
              onClick={handleView}
              className="btn btn-success p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              View
            </button>
            <button
              onClick={handleEdit}
              className="btn btn-info p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              Edit
            </button>
            <button
              onClick={HandelDelete}
              className="btn btn-danger p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              Delete
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <Table Rows={Rowdata1} columns={ColumnData} />
          </div>
        </div>
      </div>

      <Modal visible={open} width="70%" height="85%" effect="fadeInUp">
        <div style={{ "overflow-y": "auto", height: "100%" }}>
          <a className="close" onClick={() => handleCloseModal()}>
            &times;
          </a>

          <div className="row">
            <div className="col-sm-5"></div>
            {view ? null : (
              <div className="col-sm-4 fontWeight-bold text-blue">
                Organization Performance
              </div>
            )}
          </div>
          <div className="container-fluid">
            <div className="col-sm-12">
              <div className="ibox-content">
                <br />

                {view ? (
                  <div>
                    <h3>Organization Performance</h3>
                    <table className="table table-sm">
                      <tbody>
                        <tr>
                          <td className="font-weight-bold">mdaName:</td>
                          <td>{inputs.mdaName}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Financial Year:</td>
                          <td>{inputs.financialYear.name}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">
                            Core Mandate Score:
                          </td>
                          <td>{inputs.coreMandateScore}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Financial Score:</td>
                          <td>{inputs.financialScore}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">
                            Service Delivery Score:
                          </td>
                          <td>{inputs.serviceDeliveryScore}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Composite Score:</td>
                          <td>{inputs.compositeScore}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Date Signed Off:</td>
                          <td>{inputs.dateSignedOff}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">evaluatorName:</td>
                          <td>{inputs.evaluatorName}</td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    <div className="row">
                      <div class="d-flex flex-row ">
                        <button
                          className="btn btn-success p-2"
                          type="button"
                          onClick={handleEdit}
                        >
                          Update
                        </button>
                        &nbsp;
                        <button
                          onClick={HandelDelete}
                          className="btn btn-danger p-2"
                        >
                          Delete
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-warning p-2"
                          type="button"
                          onClick={handleCloseModal}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                    <br />
                  </div>
                ) : (
                  <form className="form-horizontal" onSubmit={HandleSubmit}>
                    <div>
                      <div className=" row">
                        <div className="col-sm">
                          <div className="form-group">
                            <label
                              htmlFor="Datereceived"
                              className="fontWeight-bold"
                            >
                              Organization
                            </label>
                            <select
                              className="form-control"
                              name="mdaName"
                              required
                              value={inputs.mdaName || ""}
                              onChange={handleInputChange}
                            >
                              <option value="">Select Organization</option>
                              {organizationOptions &&
                                organizationOptions.map((types) => (
                                  <option key={types.name} value={types.name}>
                                    {types.name}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-sm">
                          <div className="form-group">
                            <label
                              htmlFor="Datereceived"
                              className="fontWeight-bold"
                            >
                              Financial year
                            </label>
                            <select
                              className="form-control"
                              name="financialYearId"
                              required
                              value={inputs.financialYearId || ""}
                              onChange={handleInputChange}
                            >
                              <option value="">Select year</option>
                              {yearsOptions &&
                                yearsOptions.map((types) => (
                                  <option key={types.id} value={types.id}>
                                    {types.name}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-sm">
                          <div className="form-group">
                            <label
                              htmlFor="Datereceived"
                              className="fontWeight-bold"
                            >
                              Core Mandate Score
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="coreMandateScore"
                              required
                              value={inputs.coreMandateScore}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div className=" row">
                        <div className="col-sm">
                          <div className="form-group">
                            <label
                              htmlFor="financialScore"
                              className="fontWeight-bold"
                            >
                              Financial Score
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="financialScore"
                              required
                              value={inputs.financialScore}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-sm">
                          <div className="form-group">
                            <label
                              htmlFor="Datereceived"
                              className="fontWeight-bold"
                            >
                              Service Delivery Score
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="serviceDeliveryScore"
                              required
                              value={inputs.serviceDeliveryScore}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-sm">
                          <div className="form-group">
                            <label
                              htmlFor="Datereceived"
                              className="fontWeight-bold"
                            >
                              Composite Score
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="compositeScore"
                              required
                              value={inputs.compositeScore}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className=" row">
                        <div className="col-sm">
                          <div className="form-group">
                            <label
                              htmlFor="dateSignedOff"
                              className="fontWeight-bold"
                            >
                              Date Signed Off
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              name="dateSignedOff"
                              required
                              value={inputs.dateSignedOff}
                              onChange={handleInputChange}
                              // defaultvalue={inputs.name}
                            />
                          </div>
                        </div>
                        <div className="col-sm">
                          <div className="form-group">
                            <label
                              htmlFor="dateSignedOff"
                              className="fontWeight-bold"
                            >
                              Evaluator Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="evaluatorName"
                              required
                              value={inputs.evaluatorName}
                              onChange={handleInputChange}
                              // defaultvalue={inputs.name}
                            />
                          </div>
                        </div>
                        <div className="col-sm">
                          <div className="form-group">
                            <label
                              htmlFor="Datereceived"
                              className="fontWeight-bold"
                            >
                              Rating
                            </label>
                            <select
                              className="form-control"
                              name="ratingId"
                              required
                              value={inputs.ratingId || ""}
                              onChange={handleInputChange}
                            >
                              <option value="">Select rating</option>
                              {ratingsOptions &&
                                ratingsOptions.map((types) => (
                                  <option
                                    key={types.ratingId}
                                    value={types.ratingId}
                                  >
                                    {types.gradeName}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm">
                        <div className="row">
                          <div className="col-sm-12">
                            <div class="d-flex flex-row">
                              {update ? (
                                <button
                                  className="btn btn-success p-2"
                                  type="submit"
                                >
                                  Update
                                </button>
                              ) : (
                                <button
                                  className="btn btn-success p-2"
                                  type="submit"
                                >
                                  Submit
                                </button>
                              )}
                              &nbsp;
                              <button
                                className="btn btn-warning p-2"
                                type="button"
                                onClick={handleCloseModal}
                              >
                                Close
                              </button>
                            </div>
                            <br />
                          </div>
                        </div>
                        <br />
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default OrganizationPerformance;
